﻿import { ErrorInformation } from '../../../core/services/errorRedirectService/errorInformation.model';
import { IAuthenticationService } from '../../../authentication/authentication.service';

export class HttpErrorRedirectInterceptor implements angular.IHttpInterceptor {
    public static factory($q: angular.IQService, $injector: any, $rootScope: angular.IRootScopeService, authenticationService:IAuthenticationService): HttpErrorRedirectInterceptor {
        return new HttpErrorRedirectInterceptor($q, $injector, $rootScope, authenticationService);
    }

    constructor(private $q: angular.IQService,
        private $injector: any,
        private $rootScope: angular.IRootScopeService,
        private authenticationService: IAuthenticationService) { }

    public responseError = (response: any): any => {
        let config = response.config;
        // if the caller has specifically requested to bypass the error page, then just reject the promise
        if (config && config.bypassErrorPage) {
            return this.$q.reject(response);
        }

        if (response.status == 401) {
            let intercerptor = this;
            //if api returned a 401 attempt to refresh the token behind the scenes
            return this.authenticationService.refreshToken().then(function(){
                //if refresh is successful, reissue previously failed request
                return intercerptor.$injector.get('$http')(config);
            }, function(error){
                //otherwise reject it and let site error handling take over
                return intercerptor.$q.reject(response);
            });
        } else {
            const error = new ErrorInformation();
            error.errorMessage = `${response.status}: ${response.statusText}`;
            error.errorDetails = response.data;
    
            // note:  original intent was to use the ui router to redirect to a configurable state.  However, the UI router has a dependency on $http, so trying to inject it into an HTTPFilter caused a circular reference error at runtime
            // so instead, we had to disconnect the navigation operation from the error interception with a pub/sub event.
            this.$rootScope.$broadcast('errorRedirect', error);
            return this.$q.reject(response);
        }
    }

}

HttpErrorRedirectInterceptor.factory.$inject = ['$q', '$injector', '$rootScope', 'authenticationService'];